import React, { useContext } from 'react'
import Modal from './Modal'
import css from './Modal.module.scss'
import lCss from '../Layout/Layout.module.scss'
import {allowaccess, login} from "../../api/api";
import {UserContext} from "../../context/user";
import {TourContext} from "../../context/tour";

export default function ModalSessionActive({isOpen, params, closeModal, toggleModal}) {
    const { setUserParams } = useContext(UserContext);
    const { tour } = useContext(TourContext);

    const onSubmit = async () => {
        await allowaccess();
        const data = await login(params);
        setUserParams({...data,...(tour.tour ? {categories: []}: null)});
        closeModal();
    };

    return (
        <Modal
            isOpen={isOpen}
            closeModal={closeModal}
            style={{
                content: {
                    position:'static',
                    display: 'inline-block',
                    background: '#fff',
                    overflow: 'auto',
                    border: 'none',
                    WebkitOverflowScrolling: 'touch',
                    outline: 'none',
                    boxShadow: '5px 15px 25px rgba(0, 0, 0, 0.5)',
                    borderRadius: 'none',
                    padding: '0',
                    width:'480px',
                    maxWidth: '100%',
                    margin: '0 auto'
                }
            }}
        >
            <>
                <div className={css.title}>Вашим логином уже пользуются</div>
                <div className={css.text}>
                    Пользователь с таким логином уже работает с Базой Анонсов. Войдя в систему вы прервёте сеанс его работы.
                </div>
                <div className={css.footer}>
                    <div className={css.beetween}>
                        <input type="button" className={lCss.button + ' ' + lCss.w100 + ' ' + lCss.red} value="Войти" onClick={onSubmit}/>
                        <input type="button" className={lCss.button + ' ' + lCss.w100} value="Не Входить" onClick={() => toggleModal({sessionActive: false, login: true})}/>
                    </div>
                </div>
            </>
        </Modal>
    )
}